
import { S3 } from "@aws-sdk/client-s3";

const S3ClientUtil = new S3({
    forcePathStyle: true,
    endpoint: "https://nos.wjv-1.neo.id",
    region: "us-east-1",
    credentials: {
      accessKeyId: "1444c83168735dbf044a",
      secretAccessKey: "zPyVQ+Ikaj/T9K2hLwKD+RnxRD90MJ3+9ANlI9Oi"
    }
});

export { S3ClientUtil };